import React, { useState, useRef } from 'react'
import { useStateValue } from '@State'

export const CertPreamble = ({ disable }) => {
  const [state, dispatch] = useStateValue()
  const [editPreamble, setEditPreamble] = useState(false)
  const preambleInput = useRef(null)

  const handleChange = () => {
    dispatch({
      type: 'UPDATE_CERT_INFO',
      payload: { preamble: preambleInput.current.value },
    })
    setEditPreamble(false)
  }

  if (editPreamble) {
    return (
      <div className="text-center input_element" id="preamble">
        <input
          type="text"
          id="preamble_input"
          ref={preambleInput}
          defaultValue={state.certInfo.preamble}
          onBlur={handleChange}
        />
      </div>
    )
  }

  return (
    <div
      className={disable ? 'text-center' : 'text-center input_element'}
      id="preamble"
    >
      {state.certInfo.preamble}
      <div
        className={disable ? '' : 'icon icon_pencil'}
        id="preamble_pencil"
        onClick={() => setEditPreamble(true)}
      />
    </div>
  )
}
